"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_NAME = void 0;
var ACTION_NAME;
(function (ACTION_NAME) {
    ACTION_NAME["CREATE"] = "create";
    ACTION_NAME["READ"] = "read";
    ACTION_NAME["EDIT"] = "edit";
    ACTION_NAME["REMOVE"] = "remove";
    ACTION_NAME["PUBLISH"] = "publish";
    ACTION_NAME["ARCHIVE"] = "archive";
})(ACTION_NAME = exports.ACTION_NAME || (exports.ACTION_NAME = {}));
//# sourceMappingURL=types.js.map